jQuery(document).ready(function ($) {


	// TOP-0Page baner
	$('.slider_bnr').slick({
		infinite: true,
		slidesToShow: 3,
		autoplay: true,
		arrows: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 950, 
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},          
		],
	});
	/* ==================================
		slick slider
	================================== */
	$('.slider').not('.js-reorder-frequent-slider').slick({
		infinite: true,
		slidesToShow: 8,
		autoplay: true,
		arrows: true,
		autoplaySpeed: 3000,
		responsive: [
			{
				breakpoint: 1500, // 1500px以下のサイズに適用
				settings: {
					slidesToShow: 6,
				},
			},
			{
				breakpoint: 950, // 399px以下のサイズに適用
				settings: {
					slidesToShow: 3,
					arrows: false,
				},
			},
		],
	});

	function initReorderFrequentSlider() {
		var $el = $('.js-reorder-frequent-slider');
		if (!$el.length || !$el.children().length) return;
		if ($el.hasClass('slick-initialized')) {
			$el.slick('unslick');
		}
		$el.slick({
			infinite: true,
			slidesToShow: 5,
			slidesToScroll: 1,
			autoplay: true,
			arrows: true,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1500,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 950,
					settings: {
						slidesToShow: 2,
						arrows: false,
					},
				},
			],
		});
	}
	window.initReorderFrequentSlider = initReorderFrequentSlider;
	initReorderFrequentSlider();

	setTimeout(	
		function(){
			$('.slider').not('.js-reorder-frequent-slider').slick({
				autoplay: false,
				infinite: true,
				slidesToShow: 8,
				slidesToScroll: 8,
				responsive: [
					{
						breakpoint: 1500, // 1500px以下のサイズに適用
						settings: {
							slidesToShow: 6,
							slidesToScroll: 6,
						},
					},
					{
						breakpoint: 950, // 399px以下のサイズに適用
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							arrows: false,
						},
					},
				],
			});
			initReorderFrequentSlider();
	},3500)

	/* ==================================
		Product banner slick slider
	================================== */


	$('.slick-slider.product-banner').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 500,   
		easing: 'ease-in-out',
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1, 
                    slidesToScroll: 1,
					centerMode: true,
                    dots: false,      
                    arrows: false,    
                }
            }
        ]
	});
	/* ==================================
		global menu
	================================== */
	$(".openbtn").click(function () {
		$(this).toggleClass('active');
		$("#g-nav").toggleClass('panelactive');
	});

	$("#g-nav a,#g-nav-bg").click(function () {
		$(".openbtn").removeClass('active');
		$("#g-nav").removeClass('panelactive');
	});

	/* ==================================
		 Anchor Link
	================================== */
	var pos = 0;
	$(window).scroll(function () {
			if (window.matchMedia( "(max-width: 959px)" ).matches) {
				if ($(this).scrollTop() > 100) {
					$('.w_Head').addClass('scroll');
					$('.PageTop').fadeIn();
				} else {
					$('.w_Head').removeClass('scroll');
					$('.PageTop').fadeOut();
				}

			} else {
				if ($(this).scrollTop() > 100) {
					$('.w_Head').addClass('scroll');
					$('.PageTop').fadeIn();
				} else {
					$('.w_Head').removeClass('scroll');
					$('.PageTop').fadeOut();
				}
			}

		$(".passing").each(function(){
			var imgPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > imgPos - windowHeight + windowHeight / 4){
				$(this).addClass('move');
			}
		});
	});

	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		position = position - $('.w_Head').outerHeight();
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
	// ページ内アンカーリンク設定
	$('a[href*="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var home = location.origin + '/';
		href = href.replace(home, "");
		href = href.replace('wp/', "");
		//console.log(href);
		if (href.slice(0,1) == '#' || href == "") {
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top;
			position = position - $('.w_Head').outerHeight();
			$("html, body").animate({scrollTop:position}, speed, "swing");
		//if ($('body').data('elementor-device-mode') == 'mobile') {
		//	$("#responsive-btn").trigger('click');
		//}
			return false;
		}
	});

	/* ==================================
			Modal Window
	================================== */
	$('.js_modal').on('click', function () {
		var isMobile = $(window).width() < 768;
		var modalId = '#modal_' + $(this).attr('data-modal') ;

		if (modalId === '#modal_product_detail' && isMobile) {
			return; 
		}
		if ($(this).attr('class').match('js_modal')) {
			
		
			//alert($(this).attr('class'));
			$(modalId + ' .modal_window').fadeIn();
			$(modalId + ' .modal_box').fadeIn();
			$(modalId + ' .modal_img img').attr('src', $(this).data('src'));
			$('#CategoryWindow').addClass('open');
			$("html").addClass("over_hidden");
		}
	});
	$('.modal_close,.modal_window').click(function () {
		$('.modal_window').fadeOut();
		$('.modal_box').fadeOut();
		$('html').removeClass('open');
		$("html").removeClass("over_hidden");
	});


	//Product Category
	$(document).click(function(event) {
	//	alert("clicked: 要素名=" + event.target.nodeName + "&nbsp;ID="+ event.target.id + "&nbsp;Class=" +event.target.className);
		var idName = event.target.id;
		var className = event.target.className;
		if(idName && typeof idName === 'string' && idName.match('MakeShopTopCatyegorySelect') || className.match('product_cat_name')){
			if($('html').hasClass('open')){
				$('.head_cat_wrp').hide();
				$('html').removeClass('open');
				$('#shopify-section-bbnet-header').removeClass('open');
			} else {
				$('#shopify-section-bbnet-header').addClass('open');
				$('.head_cat_wrp').show();
                $('html').addClass('open');
			}
		}
	});

  	/* ==================================
			Accordion
	================================== */
	// 初期状態でFAQアコーディオンを開いた状態にする
	$(document).ready(function(){
		$('.qa_lst .accordion_btn').addClass("open");
	});
	
   $(document).on('click', '.accordion_btn', function(){
		// $(this).next('.accordion_inner').slideToggle();
		$('.accordion_inner').slideToggle();
		$(this).toggleClass("open");
	});  

    $('input[name="radio_corporation"]').click(function(){
        var $radio = $(this);

        // if this was previously checked
        if ($radio.data('waschecked') == true)
        {
            $radio.prop('checked', false);
            $radio.data('waschecked', false);
        }
        else
            $radio.data('waschecked', true);
    });
});


// my page menu overlay display 
const dropdown = document.querySelector(".dropdown");
const overlay = document.querySelector(".overlay")

dropdown && dropdown.addEventListener("mouseenter" , function() {
   overlay.style.display = "block";
})
dropdown && dropdown.addEventListener("mouseleave" , function() {

   overlay.style.display = "none";
})